import $ from 'jquery';


const Media = {
  playClass: 'js-mediaPlay',

  init() {
    this.play();
  },

  play() {
    $("." + this.playClass).each(function () {
      let dataDelay = $(this).data("delay");
      if (dataDelay === undefined) {
        dataDelay = 100;
      }

      setTimeout(() => {
        if (this.tagName === "VIDEO") {
          $(this).get(0).play();
        } else if (this.tagName === "IFRAME") {
          let playerWindow = $("iframe", this)[0].contentWindow;
          playerWindow.postMessage(
            '{"event":"command", "func":"playVideo", "args":""}',
            "*"
          );
        }
      }, dataDelay);
    });
  },
}

export default Media;